import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import Select, { components } from 'react-select';

import Icon from '../Icon';
import Text from '../Text';

import StyledFilterSelect from './FilterSelect.style';

export type FilterSelectProps = {
  value?: string | any[] | { label: string; value: string };
  name: string;
  options: any[];
  label: string;
  isMulti?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onChange: (data: any) => void;
};

const Control = (props: any) => {
  const {
    children,
    selectProps: { filterLabel }
  } = props;

  return (
    <components.Control {...props}>
      <Text variant="form-value">{filterLabel}</Text>
      {children}
    </components.Control>
  );
};

const DropdownIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <Icon icon="Expand" size="tiny" />
  </components.DropdownIndicator>
);

const NoOptionsMessage = (props: any) => {
  const { t } = useTranslation('common');
  return (
    <components.NoOptionsMessage {...props}>
      <Text variant="copy-small">{t('form.labels.noOptions')}</Text>
    </components.NoOptionsMessage>
  );
};

const MultiValueLabel = ({ children, ...props }: any) => (
  <components.MultiValueLabel {...props}>
    <Text variant="copy-small" title={children}>
      {children}
    </Text>
  </components.MultiValueLabel>
);

const Placeholder = ({ children, ...props }: any) => (
  <components.Placeholder {...props}>
    <Text variant="form-value">{children}</Text>
  </components.Placeholder>
);

const Option = ({ children, ...props }: any) => (
  <components.Option {...props}>
    <Text variant="form-value">{children}</Text>
  </components.Option>
);

const ClearIndicator = (props: any) => (
  <components.ClearIndicator {...props}>
    <Icon icon="Reset" size="tiny" />
  </components.ClearIndicator>
);

const MultiValueRemove = (props: any) => (
  <components.MultiValueRemove {...props}>
    <Icon icon="Reset" size="tiny" />
  </components.MultiValueRemove>
);

const FilterSelect = ({
  value,
  placeholder,
  label,
  disabled,
  name,
  isMulti = true,
  isSearchable = true,
  isClearable = true,
  options,
  onChange
}: FilterSelectProps) => {
  return (
    <StyledFilterSelect>
      <label htmlFor={name}>
        <Text variant="form-label">{label}</Text>
      </label>

      <Select
        id={name}
        defaultValue={value}
        value={value}
        name={name}
        placeholder={placeholder}
        className="filter-select__container"
        classNamePrefix="filter-select"
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        options={options}
        onChange={onChange}
        isDisabled={disabled}
        components={{
          ClearIndicator,
          Placeholder,
          MultiValueRemove,
          Control,
          DropdownIndicator,
          NoOptionsMessage,
          MultiValueLabel,

          Option
        }}
      />
    </StyledFilterSelect>
  );
};

export default FilterSelect;
